<template>
  <div class="hello">
    <hdSimple class="header"></hdSimple>
    <!--<ul class="clearfix crumbs gray-txt">
      <li>123<span>/</span></li>
    </ul>-->
    <div class="main-content">
      <router-view/>
    </div>
    <!--<ft class="ft"></ft>-->
    <GlobalDialogs></GlobalDialogs>
  </div>
</template>

<script>
import hdSimple from './HeaderSimple'
import ft from './Footer'
import GlobalDialogs from './GlobalDialogs'

export default {
  name: 'HelloWorld',
  components: {
    hdSimple: hdSimple,
    ft: ft,
    GlobalDialogs: GlobalDialogs
  },
  computed: {
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .header {
    border-bottom: 1px solid #d7d7d7;
  }
  .crumbs {
    margin-top: 34px;
    max-width: 1200px;
    margin: 34px auto 10px;
  }
  .main-content {
    margin-top: 70px;
    .select-shop {
      max-width: 760px;
      margin: 0 auto;
    }
    .publish-task-product {
      max-width: 1140px;
      margin: 0 auto;
    }
  }
  @media (max-width: 768px) {
    .main-content {
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LayoutSimple.vue